export default "__VITE_ASSET__CmUviblv__";